import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-array-list-modal',
  standalone: true,
  imports: [NgFor, NgIf, NgTemplateOutlet],
  templateUrl: './array-list-modal.component.html',
  styleUrls: ['./array-list-modal.component.scss'],
})
export class ArrayListModalComponent {
  @Input() items: unknown[] = [];
  @Input() itemTemplate: TemplateRef<unknown> | null = null;

  formatItem(item: unknown): string {
    if (item === null || item === undefined) {
      return '';
    }

    if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
      return String(item);
    }

    if (typeof item === 'object' && 'name' in (item as Record<string, unknown>)) {
      const value = (item as { name?: unknown }).name;
      return value !== undefined && value !== null ? String(value) : '';
    }

    return '';
  }
}

